import React from "react";
import {
  TrophyIcon,
  ListBulletIcon,
  ChatBubbleBottomCenterIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { formatNumber } from "../../../helpers/NumberFormats";

interface RapperStatBarProps {
  stats: {
    communityRank: number | null;
    listAppearances: number;
    averageRank: number | null;
    totalReactions: number;
    totalComments: number;
    debateCount: number;
    points: number;
  };
}

const RapperStatBar: React.FC<RapperStatBarProps> = ({ stats }) => {
  const statCards = [
    {
      label: "Community Rank",
      value: stats.communityRank ? `#${stats.communityRank}` : "Unranked",
      icon: TrophyIcon,
      color: stats.communityRank ? "text-yellow-500" : "text-gray-400",
    },
    {
      label: "Appears In Lists",
      value: formatNumber(stats.listAppearances),
      icon: ListBulletIcon,
      color: "text-blue-400",
    },
    {
      label: "Average Rank",
      value: stats.averageRank ? stats.averageRank.toFixed(1) : "N/A",
      icon: ChartBarIcon,
      color: "text-green-400",
    },
    {
      label: "Total Points",
      value: formatNumber(stats.points),
      icon: ChartBarIcon,
      color: "text-purple-400",
    },
    {
      label: "Debates",
      value: formatNumber(stats.debateCount),
      icon: ChatBubbleBottomCenterIcon,
      color: "text-orange-400",
    },
    {
      label: "Comments",
      value: formatNumber(stats.totalComments),
      icon: ChatBubbleBottomCenterIcon,
      color: "text-pink-400",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
      {statCards.map((stat, index) => (
        <div
          key={index}
          className="bg-gray-800/50 rounded-lg p-4 border border-gray-700"
        >
          <div className="flex items-center justify-between mb-2">
            <stat.icon className={`w-5 h-5 ${stat.color}`} />
          </div>
          <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
          <div className="text-xs text-gray-400 uppercase tracking-wide">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RapperStatBar;
